<template>
  <div>
    <v-toolbar class="pl-nav-content white" flat light app fixed>
      <v-toolbar-title>Decks</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <deck-list />
  </div>
</template>

<script>
import DeckList from '@/components/Deck/DeckList'
import { mapActions } from 'vuex'

export default {
  name: 'DecksIndex',

  components: {
    DeckList
  },

  mounted () {
    this.getDecks()
  },

  methods: {
    ...mapActions('decks', ['getDecks'])
  }
}
</script>
